export default __webpack_public_path__ + "static/media/wave-light.1123b95b.svg";